import {Service} from 'typedi';
import type {SearchApiDocument} from '../../../../api/model/response/documents/SearchResult';
import type {CardTypeStrategyData} from '../../types/card-strategy-data.type';
import {StrategyBuilder} from '../../StrategyBuilder';
import {CardStrategyService} from '../../CardStrategyService';


@Service({id: 'mobileAppsCardStrategyService'})
export class MobileAppsCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {

  build(details:CardTypeStrategyData): CardStrategyService {
      return new MobileAppsCardStrategyService(details);
  }
}

export class MobileAppsCardStrategyService extends CardStrategyService {
  details;

  constructor(details:CardTypeStrategyData) {
      super();
      this.details = details;
  }

  makeCard(doc:SearchApiDocument) {
      return 'uiaas-search-result-mobile-apps';
  }

  getCardProps(doc: SearchApiDocument, params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
